import { useState, useCallback } from 'react';
import { UseRadioButtonGroupReturn } from '@/shared/types/radiobutton';

interface UseRadioButtonGroupProps {
  value?: string;
  onChange?: (value: string) => void;
  options: Array<{ value: string; label: string; disabled?: boolean }>;
}

/**
 * Hook personalizado para manejar la lógica del RadioButtonGroup
 */
export const useRadioButtonGroup = ({
  value: controlledValue,
  onChange,
  options,
}: UseRadioButtonGroupProps): UseRadioButtonGroupReturn => {
  const [internalValue, setInternalValue] = useState<string | undefined>(controlledValue);

  // Usar valor controlado si se proporciona, sino usar valor interno
  const selectedValue = controlledValue !== undefined ? controlledValue : internalValue;

  const handleChange = useCallback(
    (newValue: string) => {
      // Si hay un onChange controlado, usarlo
      if (onChange) {
        onChange(newValue);
      } else {
        // Sino, actualizar el estado interno
        setInternalValue(newValue);
      }
    },
    [onChange],
  );

  return {
    selectedValue,
    handleChange,
  };
};
